import type { FC } from 'react';
import React from 'react';
import type { CustomArtMobileProps } from './CustomArtMobile.types';
import { Box } from '@withjoy/joykit';
import { backgroundImageForUrl } from '@shared/utils/style/backgroundImage';

export const CustomArtMobile: FC<CustomArtMobileProps> = ({ backgroundImageUrl }) => {
  if (!backgroundImageUrl) {
    return null;
  }

  return (
    <Box
      right={0}
      width="100%"
      bottom={0}
      height="100%"
      position="absolute"
      pointerEvents="none"
    >
      <Box
        width="100%"
        height="100%"
        position="absolute"
        backgroundSize="cover"
        backgroundImage={backgroundImageForUrl(backgroundImageUrl)}
        backgroundRepeat="no-repeat"
        backgroundPosition="center bottom"
      />
    </Box>
  );
};

CustomArtMobile.displayName = 'CustomArtMobile';
